import e from"./HierarchicalMenuList.vue_vue&type=script&lang.js";import{render as r}from"./HierarchicalMenuList.vue_vue&type=template&id=34a24b26&lang.js";e.render=r;export default e;
//# sourceMappingURL=HierarchicalMenuList.vue.js.map
